<script setup lang="ts">
import { CATEGORIES_MAP } from "~/utils/categories";
import type { NewsResponse } from '~/types/news';

definePageMeta({
  middleware: ['pagination']
});

const route = useRoute();
const slugParts = (route.params.slug as string[]) || [];

// Determinar si estamos en una categoría y qué página mostrar
const isCategory = slugParts.length > 0 && slugParts[0] !== 'page';
const categorySlug = isCategory ? slugParts[0] as keyof typeof CATEGORIES_MAP : undefined;

// Calcular la página actual
const currentPage = ref(1);

const updateCurrentPage = () => {
  const parts = (route.params.slug as string[]) || [];
  const pageIdx = parts.findIndex(part => part === 'page');
  currentPage.value = pageIdx !== -1 ? Number(parts[pageIdx + 1]) || 1 : 1;
};

// Actualizar la página cuando cambie la ruta
watch(() => route.params.slug, updateCurrentPage, { immediate: true });

// Obtener información de la categoría si estamos en una
const category = categorySlug ? CATEGORIES_MAP[categorySlug] : undefined;
const categoryName = category?.name ?? '';

// Obtener las noticias
const { data: response, status } = await useFetch<NewsResponse>("/api/latestNews", {
  query: { 
    page: currentPage.value,
    ...(category && { categoryId: category.id })
  },
  watch: [currentPage]
});

const isLoading = computed(() => status.value === 'pending');
const newsList = computed(() => response.value?.newsList ?? []);
const count = computed(() => response.value?.count ?? 0);
</script>

<template>
  <UContainer>
    <h1 v-if="categoryName" class="text-3xl font-bold my-8 text-center">{{ categoryName }}</h1>
    <div v-if="isLoading">Cargando...</div>
    <template v-else>
      <NewsList :newsList="newsList" />
      <PaginationNews 
        :count="count" 
        :current-page="currentPage" 
        :category="categorySlug"
      />
    </template>
  </UContainer>
</template> 